<template>
  <div class="progress-bar-container">
    <div :class="{'progress-bar-circle': true, 'progress': isStarted && !isComplete, 'completed': isComplete}"></div>
    <div class="progress-bar-line-container">
      <div class="progress-bar-line">
        <div class="progress" v-if="isStarted && !isComplete" :style="{width:percent + '%'}"></div>
        <div class="completed" v-if="isComplete" :style="{width:percent + '%'}"></div>
      </div>
    </div>
    <div :class="{'progress-bar-circle': true, 'completed': isComplete}"></div>
  </div>
</template>

<style lang="scss" scoped>
$dot-size: 15px;
$background-colour: #c4c6d8;
$completed-colour: #3EB240;
$waiting-colour: #757997;
$progress-colour: #FF8D3B;

.progress-bar-container {
  width: 100%;
  height: $dot-size;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.progress-bar-circle {
  width: $dot-size;
  height: $dot-size;
  display: inline-block;
  border-radius: 50%;
  border: 2px solid $waiting-colour;
}
.progress-bar-circle.progress {
  border-color: $progress-colour;
  border-width: 3px;
}
.progress-bar-circle.completed {
  border-color: $completed-colour;
  background-color: $completed-colour;
  border-width: 3px;
}
.progress-bar-line-container {
  flex: 1;
  position: relative;
}
.progress-bar-line {
  position: absolute;
  display: block;
  top: 5px;
  left: 5px;
  right: 5px;
  height: 4px;
  background-color: #c4c6d8;
}
.progress-bar-line > .progress {
  height: 100%;
  background-color: $progress-colour;
}
.progress-bar-line > .completed {
  height: 100%;
  background-color: $completed-colour;
}
</style>


<script>
export default {
  name: 'ProgressBar',
  props: {
    percent: Number
  },
  computed: {
    isComplete() {
      return this.percent >= 100.0
    },
    isStarted() {
      return this.percent > 0.0
    }
  }
}
</script>